import './App.css';
import RouterApp from './routes';

function App() {
  return <RouterApp />
}

export default App;
